import { IAPIRoutes } from "../../../../config";

export type IDeviceRepository = ReturnType<typeof DeviceRepositoryFactory>;

export const DeviceRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getDeviceConnectionStatusAPI: IGetDeviceConnectionStatusAPI = async (
    payload
  ) =>
    GET(
      APIRoutes.apiGetDeviceConnectionStatus.replace(
        "{device_id}",
        payload.device_id
      ),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getDeviceConnectionStatusAPI,
  };
};
